/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceLevelFeaturesResource
 */
export interface ServiceLevelFeaturesResource {
    /**
     * Whether the organization can upload client terms
     * @type {boolean}
     * @memberof ServiceLevelFeaturesResource
     */
    canUploadClientTerms: boolean;
    /**
     * Whether the organization can enable cash advance
     * @type {boolean}
     * @memberof ServiceLevelFeaturesResource
     */
    canEnableCashAdvance: boolean;
}

/**
 * Check if a given object implements the ServiceLevelFeaturesResource interface.
 */
export function instanceOfServiceLevelFeaturesResource(value: object): value is ServiceLevelFeaturesResource {
    if (!('canUploadClientTerms' in value) || value['canUploadClientTerms'] === undefined) return false;
    if (!('canEnableCashAdvance' in value) || value['canEnableCashAdvance'] === undefined) return false;
    return true;
}

export function ServiceLevelFeaturesResourceFromJSON(json: any): ServiceLevelFeaturesResource {
    return ServiceLevelFeaturesResourceFromJSONTyped(json, false);
}

export function ServiceLevelFeaturesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceLevelFeaturesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'canUploadClientTerms': json['canUploadClientTerms'],
        'canEnableCashAdvance': json['canEnableCashAdvance'],
    };
}

export function ServiceLevelFeaturesResourceToJSON(value?: ServiceLevelFeaturesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'canUploadClientTerms': value['canUploadClientTerms'],
        'canEnableCashAdvance': value['canEnableCashAdvance'],
    };
}

